import ComingSoon from './ComingSoon';
import { BarChart3 } from 'lucide-react';

const DashboardInterface = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <header className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <BarChart3 className="h-8 w-8" />
          Dashboard
        </h1>
        <p className="text-gray-500 mt-2">
          Analytics and insights for your documents
        </p>
      </header>
      <ComingSoon
        title="Analytics Dashboard"
        description="Document statistics, processing insights, and visual analytics will be available soon."
        icon={<BarChart3 className="h-8 w-8 text-blue-600" />}
      />
    </div>
  );
};

export default DashboardInterface;
